import React from "react";
import { IResourceComponentsProps, BaseRecord } from "@refinedev/core";
import Cw8List from "components/cw8/Cw8List";

export const CopyRightsList: React.FC<IResourceComponentsProps> = () => {

    const resourceName :string = 'copyRight';
    return (
        <Cw8List
            resourceName = {resourceName}
        ></Cw8List>
    );
};
